import { render } from "./afterSales.vue?vue&type=template&id=d3fb1b94&scoped=true"
import script from "./afterSales.vue?vue&type=script&lang=js"
export * from "./afterSales.vue?vue&type=script&lang=js"

import "./afterSales.vue?vue&type=style&index=0&id=d3fb1b94&scoped=true&lang=css"
import "./afterSales.vue?vue&type=style&index=1&id=d3fb1b94&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-d3fb1b94"

export default script